export const UPDATE_SPECIALS_LIST = 'specials/UPDATE_SPECIALS_LIST'
export const UPDATE_BUY_SPECIALS = 'specials/UPDATE_BUY_SPECIALS'

// headerBar
export const UPDATE_SHOPPING_COUNT = 'headerBar/UPDATE_SHOPPING_COUNT'

// shoppingProgress
export const UPDATE_REMOVE_SPECIAL = 'specials/UPDATE_REMOVE_SPECIAL'